export default {
      id: "hm_open-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#hm_open-usage",
      toString: function () {
        return this.url;
      }
    }